import _ from "lodash";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import * as actions from "data/mediagroups/actions";
import RaisedButton from "material-ui/RaisedButton";
import { Page, PageSection, PageBlock, RightDrawer } from "components/Page";

import Subheader from "material-ui/Subheader";
import Row from "components/Form/Row";
import MenuLink from "components/Navigation/MenuLink";
import ImageField from "components/Form/ImageField";
import DeleteButton from "components/Buttons/DeleteButton";

import Field from "components/Form/Field";

class Mediagroup extends Component {
  state = {};

  static contextTypes = {
    router: PropTypes.object
  };

  handleCancel(id) {
    this.context.router.history.push("/admin/mediagroups");
  }

  componentWillMount() {
    this.props.fetchMediagroup(this.props.params.id);
  }

  handleDeleteClick = () => {
    this.props.deleteMediagroup(this.props.params.id);
    this.context.router.history.push("/admin/mediagroups");
  };

  handleFormSubmit(event) {
    var data = _.map(this.refs, (r, i) => {
      return { [i]: r.state.value || "" };
    });
    let merged = Object.assign(...data);

    merged.logoUrl = this.refs.logo.state.url || "";
    merged.bgimageUrl = this.refs.bgimage.state.url || "";
    merged.themeimageUrl = this.refs.themeimage.state.url || "";

    this.props.updateMediagroup(this.props.params.id, merged);
  }

  render() {
    if (!this.props.mediagroup) {
      return null;
    }
    return [
      <RightDrawer key="right">
        <PageBlock label="Mediehus" >
          <DeleteButton handleClick={this.handleDeleteClick} />              
        </PageBlock>
      </RightDrawer>,
      <Page key="page" ready={!this.props.pending}>
        <Subheader>
          <MenuLink label="Mediehus" to="/admin/mediagroups" />
          <span className="pathsep" />
          <MenuLink
            label={this.props.mediagroup.name}
            to={this.props.params.id}
          />
        </Subheader>
        <div
          onSubmit={this.handleFormSubmit.bind(this)}
          className="form-inline"
        >
          <PageSection label="Översikt">
            <Row>
              <Field
                ref="name"
                value={this.props.mediagroup.name}
                floatingLabelText="Mediehus / namn"
              />
            </Row>
            <Row>
              <Field
                ref="url"
                value={this.props.mediagroup.url}
                floatingLabelText="Hemsida / URL"
              />
            </Row>
            <Row>
              <Field
                ref="subtitle"
                value={this.props.mediagroup.subtitle}
                floatingLabelText="Underrubrik"
              />
            </Row>
            <Row>
              <Field
                multiLine={true}
                ref="description"
                value={this.props.mediagroup.description}
                floatingLabelText="Beskrivning"
              />
            </Row>
          </PageSection>
          <PageSection label="Bilder">
            <Row styleName="padded">
              <ImageField
                ref="logo"
                value={this.props.mediagroup.logo}
                url={this.props.mediagroup.logoUrl}
                label="Logotyp, png 400 x 400"
              />
            </Row>
            <Row styleName="padded">
              <ImageField
                ref="themeimage"
                value={this.props.mediagroup.themeimage}
                url={this.props.mediagroup.themeimageUrl}
                label="Temabild liten, jpg 300 x 150"
              />
            </Row>
            <Row styleName="padded">
              <ImageField
                ref="bgimage"
                value={this.props.mediagroup.bgimage}
                url={this.props.mediagroup.bgimageUrl}
                label="Temabild stor, jpg 1500 x 240"
              />
            </Row>
            <Row styleName="padded">
              <RaisedButton
                onTouchTap={this.handleFormSubmit.bind(this)}
                primary={true}
                label="Spara"
              />
              <RaisedButton
                onTouchTap={this.handleCancel.bind(this)}
                label="Stäng"
              />
            </Row>
          </PageSection>
        </div>
      </Page>
    ];
  }
}

function mapStateToProps(state, ownProps) {
  return {
    mediagroup: state.mediagroups.details.data,
    pending: state.mediagroups.details.pending
  };
}

export default connect(mapStateToProps, actions)(Mediagroup);



// WEBPACK FOOTER //
// ./src/pages/admin/mediagroups/Mediagroup.jsx